'use client'

import {
  ProductCardProvider,
  useProductCardContext,
} from '@/components/common/product-card/context/product-card-context'
import { Spinner } from '@/components/extension/spinner'
import { FlashSaleProduct } from '@/types/flash-sale'
import { ProductItemInfo } from './product-item-info'
import { ProductItemThumbnail } from './product-thumbnail'

type Props = {
  product: FlashSaleProduct
  type: 'current' | 'next'
}

const ProductCardContent = ({ type }: { type: 'current' | 'next' }) => {
  const { isPendingAddToCart } = useProductCardContext()

  return (
    <div className='relative w-full shrink-0 grow-0'>
      {isPendingAddToCart ? (
        <div
          className='absolute inset-0 z-10 flex items-center justify-center bg-neutral-100/50'
          role='status'
          aria-label='Adding to cart'
        >
          <Spinner size='large' />
        </div>
      ) : null}
      <figure className='space-y-3' role='group' aria-label='Product card'>
        <ProductItemThumbnail />
        <ProductItemInfo type={type} />
      </figure>
    </div>
  )
}

export const ProductItem = ({ product, type }: Props) => {
  return (
    <ProductCardProvider product={product}>
      <ProductCardContent type={type} />
    </ProductCardProvider>
  )
}
